import './testimonials-carousel.css';
import Slider from '../slider/slider';

export default (element, data) => {
  const init = () => {
    const el = element.querySelector('[data-testimonials-carousel]');

    let slider = new Slider({
      el,
      options: {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: Number(data.autoplaySpeed) * 1000,
        },
      },
    });
  };
  init();
};
